module.exports = __webpack_public_path__ + "static/capita-7d7bec9cbafe41ddac2e1c4f321bbffe.png";